












import Vue from 'vue';
export default Vue.extend({
  name: 'core-crumb',
  props: {
    color: {
      type: String,
      default: 'primary'
    }
  },
  data: () => ({ crumb: false }),
  computed: {
    routeName(): string {
      const name = this.$route.name;
      if (name != null) {
        return name.replace(/-/g, ' ');
      }
      return '';
    }
  },
  methods: {
    onScroll() {
      if (typeof window === 'undefined') return;

      const top = window.pageYOffset || document.documentElement.offsetTop || 0;

      this.crumb = top > 100;
    }
  }
});
